<template>
	<el-dialog :title="voteDetail.name" :before-close="cancel" append-to-body :visible.sync="voteResultDialogVisible"
		width="1250px" center>
		<div class="" slot="title" style="display: flex;align-items: center;justify-content: center;width: 100%;">
			<div class=""  style="width: 80%;line-height: 24px;font-size: 18px;color: #303133;text-align: center;">
				{{voteDetail.name}}
			</div>
		</div>
		
		<!-- {{voteDetail}} -->
		<!-- type="border-card" -->
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="表决结果统计" name="first">
				<div class="vote-result">
					<div class="flex align-center justify-between">
						<div class="vote-title">
							<h4>是否有弃权: {{ voteDetail.allowWaive ? '是' : '否' }}</h4>
							<h4>是否显示占比: {{ voteDetail.showProportion ? '是' : '否' }}</h4>
							<h4>签到未投是否参与占比计算: {{ voteDetail.calculateRule === 0 ? '否' : '是' }}</h4>
						</div>
						<div class="">
							<el-button icon="el-icon-daochu" @click="exportStatusResults">表决结果导出
							</el-button>
						</div>

					</div>

					<!-- <el-card> -->
					<div style="padding-bottom:50px">
						<!-- {{voteDetailList}} -->
						<div class="box-card" v-for="(item, index) in voteDetailList" :key="index">
							<!-- <div slot="header" class="clearfix">
                                    <i class="iconfont icon-shuxian"></i>
                                    <span>{{ item.groupName }}</span>
                                </div> -->
							<el-table :data="item.voteDetails" style="width: 100%" key="table1" ref="table1">

								<el-table-column label-class-name="th_1" fixed="left" align="center" prop="voteName"
									width="80">
									<template slot="header">
										<div class="" style="">
											{{ item.groupName }}
										</div>
									</template>
								</el-table-column>
								<el-table-column fixed="left" align="center" prop="voteNums" label="全部表决人员"
									min-width="100">
									<template slot-scope="scope">{{ scope.row.voteNums}}</template>
								</el-table-column>
								<el-table-column fixed="left" align="center" prop="voteSigned" min-width="100"
									:label="meetingData[0].began ? '到会表决人员' : '测试表决人员'">
									<template slot-scope="scope">
										<!-- {{ scope.row.waiver  scope.row.voteSigned}} -->
										<div class="" style="color: #000000;font-weight: bold;">
											{{ scope.row.voteSigned }}
										</div>
										<!-- <div class="" style="color: #A6A6A6;margin-top: -20px;">
										{{ keepTwoDecimalFull(scope.row.voteSigned / scope.row.voteNums * 100)}}%
									</div> -->
									</template>
								</el-table-column>
								<el-table-column fixed="left" align="center" prop="voted" label="已投票" min-width="100">
									<template slot-scope="scope">{{ scope.row.voted}}</template>
								</el-table-column>
								<el-table-column fixed="left" align="center" prop="voteSignNoVote" label="签到未投"
									min-width="100">
									<template slot-scope="scope">
										<!-- {{ scope.row.voteSignNoVote }} -->
										<div class="">
											{{ scope.row.voteSignNoVote[0] }}
										</div>
										<div v-if="scope.row.voteSignNoVote.length>1" class=""
											style="color: #A6A6A6;margin-top: -20px;">
											{{ scope.row.voteSignNoVote[1] }}
										</div>
									</template>
								</el-table-column>
								<template v-if="voteDetail.voteType === 'SINGLE_CHOICE'">
									<el-table-column fixed="left" align="center" prop="agree" label="同意">
										<template slot-scope="scope">
											<div class="" style="color: #00C800;">
												{{ scope.row.agree[0] }}
											</div>
											<div v-if="scope.row.agree.length>1" class=""
												style="color: #A6A6A6;margin-top: -20px;">
												{{ scope.row.agree[1] }}
											</div>
										</template>
									</el-table-column>
									<el-table-column fixed="left" align="center" prop="opposition" label="反对">
										<template slot-scope="scope">
											<!-- {{ scope.row.opposition }} -->
											<div class="" style="color: #FF5733;">
												{{ scope.row.opposition[0] }}
											</div>
											<div v-if="scope.row.opposition.length>1" class=""
												style="color: #A6A6A6;margin-top: -20px;">
												{{ scope.row.opposition[1] }}
											</div>
										</template>
									</el-table-column>
									<el-table-column fixed="left" v-if="voteDetail.allowWaive" align="center"
										prop="waiver" label="弃权">
										<template slot-scope="scope">
											<!-- {{ scope.row.waiver }} -->
											<div class="" style="color: #000000;font-weight: bold;">
												{{ scope.row.waiver[0] }}
											</div>
											<div v-if="scope.row.waiver.length>1" class=""
												style="color: #A6A6A6;margin-top: -20px;">
												{{ scope.row.waiver[1] }}
											</div>
										</template>
									</el-table-column>
								</template>
							</el-table>
							<template v-if="voteDetail.voteType === 'MULTIPLE_CHOICE'||voteDetail.voteType === 'ELECT'">
								<el-table :data="item.uckount1" style="width: 100%">
									<!-- <el-table-column fixed="left" align="center" prop="a0"></el-table-column> -->
									<el-table-column :width="citem.name === 'ak' ? 80 : 160"
										v-for="(citem, index) in item.uckount" :key="index"
										:fixed="citem.name === 'ak' ? true : false" :prop="citem.name"
										:label="citem.label" align="center">
										<template slot-scope="scope">
											<div class="" style="color: #191E24;">
												{{index!=0?scope.row[citem.name][0]:scope.row[citem.name][0]}}
											</div>
											<div v-if="scope.row[citem.name].length>1" class=""
												style="color: #A6A6A6;margin-top: -20px;">
												{{index!=0?scope.row[citem.name][1]:''}}
											</div>
										</template>
									</el-table-column>
								</el-table>
							</template>

						</div>
					</div>
					<!-- <div class="vote-result-export">
						<el-tooltip class="item" effect="dark" content="表决结果导出" placement="top">
							<i class="iconfont icon-daochu" @click="exportStatusResults"></i>
						</el-tooltip>
					</div> -->
					<!-- </el-card> -->
				</div>
			</el-tab-pane>
			<el-tab-pane label="表决结果详情" name="second">
				<!-- <div class="vote-result-header">
					<i class="iconfont icon-shuxian"></i>
					<span class="title">表决人员结果</span>
				</div> -->
				<!-- <div class="vote-result"> -->
				<div class="votestaff-search">
					<el-form :inline="true" :model="params" class="">
						<!-- <el-form-item>
                            <el-input v-model.trim="params.keyword" clearable placeholder="请输入关键字"></el-input>
                        </el-form-item> -->
						<el-form-item>
							<el-input style="width: 170px;" v-model.trim="params.keyword" clearable
								placeholder="请输入关键字"></el-input>
						</el-form-item>
						<el-form-item>
							<el-select style="width: 130px;" v-model="params.test" placeholder="是否测试" clearable>
								<el-option label="全部" value=""></el-option>
								<el-option label="已测试" :value="true"></el-option>
								<el-option label="未测试" :value="false"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-select style="width: 130px;" v-model="params.sign" placeholder="是否签到" clearable>
								<el-option label="全部" value=""></el-option>
								<el-option label="已签到" :value="true"></el-option>
								<el-option label="未签到" :value="false"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-select style="width: 130px;" v-model="params.group_id" placeholder="类型/组别" clearable>
								<el-option v-for="item in groupData" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-select style="width: 130px;" v-model="params.optionId" placeholder="表决选项" clearable>
								<!-- <el-option label="全部" value=""></el-option> -->
								<el-option v-for="item in voteOptions" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="than">
							<span>大于</span>
						</el-form-item>
						<el-form-item>
							<el-input style="width: 150px;" v-model.trim="params.amount" clearable placeholder="债权金额">
							</el-input>
						</el-form-item>

						<el-form-item class="meeting-search-button">
							<el-button icon="el-icon-search" type="primary" @click="onSearch">查询</el-button>
						</el-form-item>
						<el-form-item class="meeting-search-button">
							<el-button icon="el-icon-daochu" @click="exportVoteResult">表决结果导出
							</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-table v-loading="tableLoading" :data="voteResultDetailList" size="medium" height="450px"
					key="table2" ref="table2">
					<el-table-column prop="serialNumber" label="序号" align="center" width="50px"></el-table-column>
					<el-table-column prop="name" label="债权人" align="center">
						<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
					</el-table-column>
					<el-table-column width="170px" prop="idNumber" label="债权人证件号" align="center">
						<template slot-scope="scope">{{ scope.row.idNumber || '无' }}</template>
					</el-table-column>
					<el-table-column width="160px" prop="phone" label="债权人手机号" align="center">
						<template slot-scope="scope">{{ scope.row.phone || '无' }}</template>
					</el-table-column>
					<el-table-column prop="agentName" label="代理人" align="center">
						<template slot-scope="scope">{{ scope.row.agentName || '无' }}</template>
					</el-table-column>
					<el-table-column width="170px" prop="agentIdNumber" label="代理人证件号" align="center">
						<template slot-scope="scope">{{ scope.row.agentIdNumber || '无' }}</template>
					</el-table-column>
					<el-table-column width="160px" prop="agentPhone" label="代理人手机号" align="center">
						<template slot-scope="scope">{{ scope.row.agentPhone || '无' }}</template>
					</el-table-column>
					<el-table-column width="120px" prop="groupName" label="债权组" align="center">
						<template slot-scope="scope">{{ scope.row.groupName || '无' }}</template>
					</el-table-column>
					<el-table-column width="120px" prop="amount" label="金额(元)" align="center">
						<template slot-scope="scope">{{ scope.row.amount ? $formatAmount(scope.row.amount) : scope.row.amount }}</template>
					</el-table-column>
					<el-table-column prop="test" label="是否测试" align="center">
						<template slot-scope="scope">
							{{ scope.row.test ? '已测试' : '未测试' }}
						</template>
					</el-table-column>
					<el-table-column prop="sign" label="是否签到" align="center">
						<template slot-scope="scope">
							{{scope.row.isAfterVoteSign?'表决结束后签到':scope.row.sign ? '已签到' : '未签到' }}
						</template>
					</el-table-column>
					<el-table-column label="表决选项" align="center">
						<template slot-scope="scope">
							{{ scope.row.voteOptions.length > 0 ? scope.row.voteOptions.map(item => item.name).join(',')
                                    : '未投'
                            }}
						</template>
					</el-table-column>
					<el-table-column v-if="voteDetail.isReason" prop="remark" width="160px" label="反对理由" align="center">
						<template slot-scope="scope">
							<div class="" :title="scope.row.remark || '无'"
								style="overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis;">
								{{ scope.row.remark || '无' }}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="createTime" label="表决时间" width="160px" align="center">
						<template slot-scope="scope">{{ scope.row.createTime || '无' }}</template>
					</el-table-column>
					<el-table-column v-if="meetingData[0].state == 'ONGOING' && userInfo.type == 'ADMIN'" align="center"
						label="操作列">
						<template slot-scope="scope">
							<el-button :disabled="!scope.row.voteOptions.length > 0" size="medium" type="text"
								@click="resetVoteClick(scope.row)">
								重置表决
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<Pagination :total="total" customClass="alone" @handleSizeChange="turnPage"
					@handleCurrentChange="turnPage">
					<!-- <template v-slot:operation>
						<el-tooltip class="item" effect="dark" content="表决结果导出" placement="top">
							<i class="iconfont icon-daochu" @click="exportVoteResult"></i>
						</el-tooltip>
					</template> -->
				</Pagination>
			</el-tab-pane>
		</el-tabs>
		<!-- <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="cancel">关 闭</el-button>
		</span> -->
	</el-dialog>
</template>

<script>
	import Pagination from '@/components/Pagination';
	import {
		getVoteResultList,
		getGroupData,
		getVoteResultCount,
		getVoteDetail
	} from '@/serve/userGrouping.js';
	import {
		getResetVote
	} from '@/serve/vms';
	export default {
		components: {
			Pagination
		},
		props: {
			voteResultDialogVisible: Boolean,
			voteDetail: Object,
			voteDetailList: Array,
			meetingData: Array,
			voteLoading: Boolean,
			userInfo: Object,
		},
		watch: {
			'voteDetail.id'(newVal) {
				if (newVal) {
					this.params = {
						name: '',
						group_id: '',
						amount: '',
						optionId: '',
						page: 0,
						rows: 20,
						sign: '',
						test: '',
					};
					this.activeName = 'first';
					this.getVoteDetail();
					this.getList();

				}
			}
		},
		data() {
			return {
				token: sessionStorage.getItem('ms_token'),
				total: 0,
				tableLoading: false,
				activeName: 'first',
				voteResultDetailList: [],
				params: {
					name: '',
					group_id: '',
					amount: '',
					optionId: '',
					page: 0,
					rows: 20,
					sign: '',
					test: '',
				},
				groups: [],
				voteOptions: [],
				groupData: []
			};
		},
		computed: {
			meetingId() {
				return this.meetingData[0] && this.meetingData[0].id;
			},
		},
		methods: {
			// 重置表决
			resetVoteClick(row) {
				this.$confirm('此操作将重置表决, 是否重置?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					getResetVote(this.voteDetail.id, row.userId, row.groupId)
						.then((res) => {
							this.$message.success('重置成功');
							this.getList();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				})

			},
			// 四舍五入保留2位小数
			keepTwoDecimalFull(num) {
				let result = parseFloat(num);
				if (isNaN(result)) {
					return false;
				}
				result = Math.round(num * 100) / 100;
				let s_x = result.toString();
				let pos_decimal = s_x.indexOf('.');
				if (pos_decimal < 0) {
					pos_decimal = s_x.length;
					s_x += '.';
				}
				while (s_x.length <= pos_decimal + 2) {
					s_x += '0';
				}
				return s_x;
			},
			// 获取分组组别
			getGroupData() {
				getGroupData(this.meetingId)
					.then((res) => {
						console.log('res', res)
						this.groupData = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 导出表决统计
			exportStatusResults() {
				let url = `/api/gathering/vote/${this.voteDetail.id}/report/details/export?access_token=` + this.token;
				this.createLabel(url);
			},
			// 导出表决结果
			exportVoteResult() {
				let url =
					`/api/gathering/vote/${this.voteDetail.id}/report/list/export?amount=` +
					this.params.amount +
					'&name=' +
					this.params.name +
					'&keyword=' +
					(this.params.keyword ? this.params.keyword : '') +
					'&test=' +
					this.params.test +
					'&sign=' +
					this.params.sign +
					'&group_id=' +
					this.params.group_id +
					'&optionId=' +
					this.params.optionId +
					'&page=0&rows=' +
					this.total +
					"&access_token=" +
					this.token;
				console.log("url:", url)
				this.createLabel(url);
			},
			createLabel(url) {
				const a = document.createElement('a');
				a.setAttribute('href', url);
				a.setAttribute('download', '表决结果');
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			// 获取表决详情
			getVoteDetail() {
				getVoteDetail(this.voteDetail.id)
					.then(res => {
						this.groups = res.groups;
						console.log('res.options:', res)
						console.log('res.options', JSON.stringify(res))
						this.voteOptions = res.options;
						let optionIdArray = [];
						res.options.forEach(item => optionIdArray.push(item.id));
						let optionId = optionIdArray.join(",");
						this.voteOptions.push({
							id: optionId,
							voteId: res.options[0].voteId,
							name: '未投'
						});
					})
					.catch(err => {
						this.$message.error(err.data.message);
					});
			},
			onSearch() {
				this.params.page = 0;
				this.params.rows = 20;
				this.getList();
			},
			// 翻页
			turnPage(attr, val) {
				this.params[attr] = val;
				this.getList();
			},
			cancel() {
				this.activeName = 'first';
				this.$emit('cancel');
			},
			handleClick() {
				// this.params = { name: '', group_id: '', amount: '', optionId: '', page: 0, rows: 20 };
				// this.activeName = 'first';
				this.getVoteDetail();
				this.getGroupData();
				this.getList();
				this.$nextTick(() => {
					this.$refs.table1.singleTable.doLayout();
					this.$refs.table2.singleTable.doLayout();
				})
			},
			// 获取表决详情
			getList() {
				this.tableLoading = true;
				getVoteResultCount(this.voteDetail.id, this.params).then(res => {
					this.total = res;
					if (this.total > 0) {
						getVoteResultList(this.voteDetail.id, this.params)
							.then(res => {
								for (let i = 0; i < res.length; i++) {
									res[i].serialNumber = i + 1;
								}
								this.voteResultDetailList = this.handleTableList(res);
								this.tableLoading = false;
							})
							.catch(err => {
								this.tableLoading = false;
								this.$message.error(err.data.message);
							});
					} else {
						this.voteResultDetailList = [];
						this.tableLoading = false;
					}
				});
			}
		}
	};
</script>
<style scoped lang="scss">
	::v-deep .el-table__fixed-right::before,
	::v-deep .el-table__fixed::before {
		height: 0px !important;
	}

	::v-deep .th_1 {
		background: #73788B !important;
		color: #FFFFFF !important;
	}

	.vote-result-header {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 5px 0;

		.iconfont {
			color: #bb3a32;
			font-size: 22px;
		}

		.title {
			font-weight: bolder;
		}
	}

	.votestaff-search {
		::v-deep .than {
			margin: 0 1%;
		}
	}

	.vote-result {
		.vote-title {
			width: 63%;
			height: 30px;
			line-height: 30px;
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: left;

			h4 {
				flex: 1;
			}
		}

		.el-card {
			margin-top: 10px;
			height: 500px;
			overflow-y: scroll;


		}

		.vote-result-export {
			position: absolute;
			bottom: 16px;
			height: 50px;
			line-height: 50px;
			padding-left: 30px;
			width: 96%;
			z-index: 999;
			background: #fff;
			box-sizing: border-box;

			.icon-daochu {
				color: #107c41;
				cursor: pointer;
				font-size: 16px;
			}
		}

		// .el-table {
		//     ::v-deep .is-leaf {
		//         background: #c22929 !important;
		//         color: #fff;
		//         text-align: center;
		//     }
		// }

		.box-card {
			padding: 20px 0;
		}

		.clearfix {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			margin: 0 0 15px 0;

			span {
				font-size: 15px;
				font-weight: bold;
			}
		}

		.iconfont {
			// color: #bb3a32;
			font-weight: bolder;
			font-size: 22px;
		}
	}
</style>